import * as React from 'react';

const HouseChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 11.8l5-5 5 5V18h-2v-4H9v4H7v-6.2zM12 4l-1.4 1.4L4 12l1 1v7h6v-4h2v4h6v-7l1-1-6.6-6.6L12 4z"
        />
    </svg>
);

HouseChunkySvg.displayName = 'HouseChunkySvg';
export default HouseChunkySvg;
